import { Component, Input, OnInit, Output } from "@angular/core";
import { getApp } from "../app";
import { Subject, Subscription } from "rxjs";
import { DocModel } from "../state/state";
import { StringUtils } from "../../../../shared/utils/string.utils";
import { Customer } from "../../../../shared/types/customers";
import { NORMAL, RESPONSIBLE } from "../field/field.component";
import { ActivatedRoute } from "@angular/router";
import { doc2Model } from "../api.service";

@Component({
  selector: "app-field-user-options",
  templateUrl: "./field-user-options.component.html",
  styleUrls: ["./field-user-options.component.scss"],
})
export class FieldUserOptionsComponent implements OnInit {
  app = getApp((app) => {
    this.app = app;
  });
  @Input() field = "";
  @Input() model: any = {};
  @Input() disabled: boolean = true;
  @Output() selected: Subject<string> = new Subject();
  private _threadSubscription: Subscription = new Subscription();
  private inputSubjectSubscription: Subscription = new Subscription();
  show: boolean = false;
  search: string = "";
  options = new Set<string>();
  startedSearch: boolean = false;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.model[this.field] !== "") {
      this.show = false;
      this.search = this.app.users.getOptionName(this.model[this.field]);
      this.app.field.openInputSubject.subscribe((value: string) => {
        if (value !== "" && value !== this.field) {
          this.show = false;
        }
      });
    }
    this.inputSubjectSubscription = this.app.field.inputSubject.subscribe(
      (value) => {
        if (value) {
          this.show = false;
        }
      }
    );

    if (this.app.view === "thread") {
      if (!this.app.thread.isNew) {
        this._threadSubscription = this.app.thread.threadSubject.subscribe(
          async (thread) => {
            let model = doc2Model("thread", thread);
            if (model[this.field] != "" && model[this.field] != undefined) {
              this.search = this.app.users.getOptionName(model[this.field]);
            }
          },
        );
      }
    }
  }

  isMatch(search: string, option: string) {
    if (option == null) {
      return;
    }
    if (search == null) {
      return false;
    }
    if (this.app.field.isMultiple(this.field)) {
      return false;
    }
    const cleanSearch = search.trim().toLowerCase();
    if (cleanSearch === "") {
      return true;
    }
    const cleanOption = option.trim().toLowerCase();
    this.startedSearch = true;
    return cleanOption.indexOf(cleanSearch) > -1;
  }

  showOptions(show: boolean) {
    this.show = show;
    this.app.field.setOpenInput(this.field);
    this.app.field.inputSubject.next(true);
  }

  toggleOption(field: string, option: any, model: DocModel) {
    if (this.app.field.isMultiple(field)) {
      this.toggleMultipleOptions(field, option, model);
    } else {
      if (model[field] === option) {
        // deselect option
        model[field] = "";
        return;
      }
      model[field] = option.id;
    }

    this.search = option.name;
    this.show = false;
    this.filter(model[field]);
  }

  toggleMultipleOptions(field: string, option: any, model: DocModel) {
    if (StringUtils.isNullOrEmpty(option)) {
      return;
    }
    this.options = new Set(model[field]);
    if (this.options.has(option)) {
      this.options.delete(option);
    } else {
      this.options.add(option.id);
    }

    model[field] = Array.from(this.options);
    this.search = model[field];
    return model[field];
  }

  isMandatory() {
    if (
      this.app.field.isRequired(this.field) &&
      !this.app.field.isValid(this.field, this.model[this.field])
    ) {
      return true;
    } else {
      return false;
    }
  }

  getFieldType(fieldId: string) {
    switch (fieldId) {
      case "thread.dinCodeRespName":
      case "thread.componentResponsible":
      case "thread.deputy":
        if (this.app.customers.current === Customer.DB) {
          return RESPONSIBLE;
        }
        return NORMAL;
      default:
        return NORMAL;
    }
  }

  clearModel() {
    this.search = "";
    this.model[this.field] = "";
  }

  filter(option: string) {
    /** call filter functions if the filter is open */
    if (!this.app.filterList.open) {
      return;
    }
    this.model[this.field] = option;
    this.app.filterList.add();
  }

  getPlaceholder(fieldId: string) {
    if (this.app.field.isRequired(fieldId)) {
      return `${this.app.field.getLabel(fieldId)}`;
    } else {
      return "";
    }
  }

  ngOnDestroy(): void {
    if (this._threadSubscription) {
      this._threadSubscription.unsubscribe();
    }
    if (this.inputSubjectSubscription) {
      this.inputSubjectSubscription.unsubscribe();
    }
  }
}
